import { render, staticRenderFns } from "./FinancialPlanningStep1.vue?vue&type=template&id=00476540&scoped=true"
import script from "./FinancialPlanningStep1.vue?vue&type=script&lang=js"
export * from "./FinancialPlanningStep1.vue?vue&type=script&lang=js"
import style0 from "./FinancialPlanningStep1.vue?vue&type=style&index=0&id=00476540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00476540",
  null
  
)

export default component.exports